import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateBulletinActive } from 'api/v1/requests/bulletins';

export const useUpdateBulletinActive = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateBulletinActive,

    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['bulletin', variables.id],
      });

      queryClient.invalidateQueries({
        queryKey: ['bulletins'],
      });
    },
  });
};
